import React from "react";
import { styled } from "@mui/material/styles";
import { Chip, Typography } from "@mui/material";
import { chipColors } from "./constants";

const ActionChips = (props) => {
    const {noWrap, showDocName } = props;
    const { actions } = props.rule;

    return (
        <React.Fragment>
            <Typography noWrap={noWrap}>
                {actions.map((action, i) => {
                    const { actionTypeKey } = action.actionType;
                    const chipColor =
                        actionTypeKey === 1
                            ? chipColors.required
                            : actionTypeKey === 2
                            ? chipColors.optional
                            : chipColors.hidden;
                    return (
                        <ChipStyle
                            variant="outlined"
                            style={{ border: `0.2em solid ${chipColor}`, color: chipColor }}
                            key={i}
                            label={showDocName ? action.documentName : action.actionType.displayName}
                        />
                    );
                })}
            </Typography>
        </React.Fragment>
    );
};

const ChipStyle = styled(Chip)(({ theme }) => ({
    marginRight: "5px",
    marginBottom: "5px",
}));
  
export default ActionChips;
